import styled, { css } from 'styled-components';

const Skeleton = styled.span`
  @keyframes react-loading-skeleton {
    75% {
      transform: translateX(100%);
    }
    100% {
        transform: translateX(100%);
    },
  }
  position: relative;
  display: inline-block;
  .react-loading-skeleton {
    display: inline-block;
    &::after {
      ${({ $disableAnimation }) => $disableAnimation && css`animation: none; `}
      background-image: linear-gradient( 90deg, transparent, var(--highlight-color), transparent );
      animation-duration: 2s;
    }
  }
  
`;

const OverlayIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export default {
  Skeleton,
  OverlayIcon
};
